import type { ShareReadyMessage } from "@albertine/types";

export function isEmbeddedInParentFrame(): boolean {
    return parentOriginFromLocation() !== null && window.parent !== window;
}

export function parentOriginFromLocation(): string | null {
    const rawParentOrigin = new URLSearchParams(window.location.search).get(
        "parentOrigin",
    );

    if (!rawParentOrigin) {
        return null;
    }

    try {
        return new URL(rawParentOrigin).origin;
    } catch {
        return null;
    }
}

export function postMessageToParentFrame(
    parentOrigin: string | null,
    message: unknown,
) {
    if (window.parent !== window) {
        if (!parentOrigin) {
            return;
        }
        window.parent.postMessage(message, parentOrigin);
        return;
    }

    postMessageToNativeWebView(message);
}

function postMessageToNativeWebView(message: unknown) {
    const json = JSON.stringify(message);

    if (
        window.isIosNativeWebView &&
        window.webkit?.messageHandlers?.iosNativeWebView?.postMessage
    ) {
        window.webkit.messageHandlers.iosNativeWebView.postMessage(json);
        return;
    }

    if (window.AndroidBridge?.postMessage) {
        window.AndroidBridge.postMessage(json);
    }
}

export function notifyParentReady(type: ShareReadyMessage["type"], title?: string) {
    const message: ShareReadyMessage = {
        type,
        ...(title?.trim() ? { title: title.trim() } : {}),
    };

    postMessageToParentFrame(parentOriginFromLocation(), message);
}
